module.exports = __webpack_public_path__ + "static/media/personal-values.41e6c16b.png";